































import { Component, Prop, Vue } from "vue-property-decorator";

import ValueEdit from "@/commonComponents/valueEdit/valueEdit.vue";

import PageChange from "./resources/pageChange.vue";

@Component({
  components: {
    ValueEdit,
    PageChange
  }
})
export default class PageController extends Vue {
    @Prop()
    private pageNumber!: number;
    @Prop()
    private maxPage!: number;

    private onDoCommand(command : string, paramater : any)
    {
        this.$emit("doCommand", command, paramater);
    }

    private onBack()
    {
        var index = this.pageNumber - 1;
        this.onDoCommand("goPage", { page : index - 1 } );
    }

    private onNext()
    {
        var index = this.pageNumber - 1;
        this.onDoCommand("goPage", { page : index + 1 } );
    }

    private onSetValue(pageNumber)
    {
        var index = Math.floor(pageNumber) - 1;
        this.onDoCommand("goPage", { page : index } );
    }

    private get userConfigColor(){
        return this.$store.getters.userConfigColors.buttonColorCode;
    }
}
